'use client'
import { usePathname } from 'next/navigation'
import { GetHelpButton } from 'src/components/user/get-help-button'
import { VisitWebsiteButton } from 'src/components/user/visit-website-link-button'
import { BackToLoginButton } from 'src/components/user/back-to-login-button'

export const SplashFooter = () => {
  const pathname = usePathname()
  return (
    <footer className="space-y-8">
      <div className="text-center">
        {pathname === '/user/sso' ? <BackToLoginButton /> : null}
      </div>
      <div className="flex justify-between px-8">
        <GetHelpButton />
        <VisitWebsiteButton />
      </div>
    </footer>
  )
}
